<template>
    <a class="nav-link" :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')" data-toggle-second="tooltip" data-placement="top" :title="$translate('OD3dprimaV2::Template.wishlistTooltip')">
        <span :class="{'d-none' : wishListCount === 0}" class="badge-right mr-1">
            {{ wishListCount }}
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-wishlist"></use>
        </svg>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
